import { MAIN_STYLE, MAIN_STYLE_GROUPS, PRESS_EVENTS } from '../shared.js'

export const h3d = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        haspid: { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        swipe: { type: 'string' },
        groupid: { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid: { type: 'string', internal: true },
        resource: { type: 'resource', resourceType: 'model3d', label: '3D Model', inline: true },
        camera_state: { type: 'array', internal: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 320, height: 240, min_width: 40, min_height: 10,
            enabled: true, hidden: false, resource: null, camera_state: null,
        },
        styles: {
            main: {
                radius: 10,
                bg_opa: 255,
                border_width: 2,
            },
        },
    },

    editorCapabilities: ['can_transform', 'can_copy', 'has_objectmenu'],
    runtimeCapabilities: ['has_action', 'has_group'],
    firmwareSupported: true,
    events: PRESS_EVENTS,
    bindings: {
        properties: {
            bg_color: {}, bg_opa: {}, border_color: {}, border_width: {},
            radius: {}, shadow_width: {}, shadow_color: {}, shadow_ofs_x: {}, shadow_ofs_y: {},
            outline_width: {}, outline_color: {}, outline_pad: {},
        },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
    },
}
